import {
  ApiInsuranceTypeReportGroupsResponse,
  ApiProductGroupHcpcsResponse,
  ApiUsStateResponse,
} from 'src/app/core/models';

export const usStates: ApiUsStateResponse[] = [
  {
    lookupDescription: 'Alabama',
    lookupCode: 'AL',
  },
  {
    lookupDescription: 'Alaska',
    lookupCode: 'AK',
  },
  {
    lookupDescription: 'American Samoa',
    lookupCode: 'AS',
  },
  {
    lookupDescription: 'Ohio',
    lookupCode: 'OH',
  },
];

export const getUsStates = (): ApiUsStateResponse[] => usStates;

const hcpcCodes: { [key: string]: ApiProductGroupHcpcsResponse } = {
  Sensors: {
    productGroupName: 'Sensors',
    groupHcpcsCodes: ['A9276', 'K0553'],
  },
  'Sets and Reservoirs': {
    productGroupName: 'Sets and Reservoirs',
    groupHcpcsCodes: ['A4230', 'A4231', 'A4232'],
  },
  'Testing Supplies': {
    productGroupName: 'Testing Supplies',
    groupHcpcsCodes: ['A4253', 'A4259'],
  },
};

export const getProductGroupHcpcs = (urlParams: any): ApiProductGroupHcpcsResponse =>
  hcpcCodes[urlParams.hcpcGroupName];

const insuranceReportGroups: { [key: string]: ApiInsuranceTypeReportGroupsResponse } = {
  Medicare: {
    insuranceTypeName: 'Medicare',
    insuranceTypeId: 1,
    insuranceReportGroups: ['MCR'],
  },
  'Medicare Replacement': {
    insuranceTypeName: 'Medicare Replacement',
    insuranceTypeId: 2,
    insuranceReportGroups: ['MR', 'HMMCR', 'CTMCR', 'CSMCR', 'BCMCR'],
  },
};

export const getInsuranceTypeReportGroups = (urlParams: any): ApiInsuranceTypeReportGroupsResponse =>
  insuranceReportGroups[urlParams.insuranceTypeName];
